import { render, staticRenderFns } from "./ChecklistHistoricalDataList.vue?vue&type=template&id=3fbedcc9"
import script from "./ChecklistHistoricalDataList.vue?vue&type=script&lang=js"
export * from "./ChecklistHistoricalDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports